import FormRepeaterPersianTimeField from './fields/Form/RepeaterPersianTimeField.vue'
import PendingCourseApprovalCard from './cards/PendingCourseApprovalCard.vue'

const learningModuleSetup = (app) => {
    app.component('form-repeater-persian-time-field', FormRepeaterPersianTimeField)
    app.component('PendingCourseApprovalCard', PendingCourseApprovalCard)
}

export { learningModuleSetup }
